import React from 'react';
import UncontrolledPlayerScene from 'game/scenes/test/UncontrolledPlayerScene';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function UncontrolledPlayerScenePage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [UncontrolledPlayerScene],
            physics: {
              arcade: {
                debug: true,
              }
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
